<template>
  <div id="page-wrapper">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ $t('nav.training') }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
          <li class="breadcrumb-item active"><a href="javascript:void(0)">{{ $t('nav.training') }}</a></li>
        </ol>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-6" v-for="b in blogs">
          <Blog :training="b" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Blog from '@/components/training/Blog.vue'

export default {
  name: 'TrainingList',
  data: function () {
    return {
      blogs: []
    }
  },
  components: {
    Blog
  },
  created: function() {
    //get blogs
    let that = this
  this.$http.get(this.API3_PREFIX + 'training/0').then(function (response) {
    that.blogs = response.data
    console.log(that.blogs)
  }).catch(function (error) {
    console.log(error)
  });
  }
}
</script>